// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type CatalogHarvester,
  CatalogHarvesterFromJSON,
  CatalogHarvesterToJSON,
} from "../models/CatalogHarvester";
import {
  type CatalogHarvesterCreate,
  CatalogHarvesterCreateFromJSON,
  CatalogHarvesterCreateToJSON,
} from "../models/CatalogHarvesterCreate";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type PageCatalogHarvesterShort,
  PageCatalogHarvesterShortFromJSON,
  PageCatalogHarvesterShortToJSON,
} from "../models/PageCatalogHarvesterShort";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface HarvesterCreateRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  catalogHarvesterCreate: CatalogHarvesterCreate;
}

export interface HarvesterDeleteRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  harvesterId: number;
}

export interface HarvesterListRequest {
  /**
   *
   */
  tenantId: string;
}

export interface HarvesterRetrieveRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  harvesterId: number;
}

export interface HarvesterUpdateRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  harvesterId: number;
  /**
   *
   */
  catalogHarvester: CatalogHarvester;
}

/**
 *
 */
export class CatalogHarvestersApi extends runtime.BaseAPI {
  /**
   * Creates request options for harvesterCreate without sending the request
   */
  async harvesterCreateRequestOpts(
    requestParameters: HarvesterCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling harvesterCreate().'
      );
    }

    if (requestParameters["catalogHarvesterCreate"] == null) {
      throw new runtime.RequiredError(
        "catalogHarvesterCreate",
        'Required parameter "catalogHarvesterCreate" was null or undefined when calling harvesterCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/catalog-harvesters`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CatalogHarvesterCreateToJSON(requestParameters["catalogHarvesterCreate"]),
    };
  }

  /**
   * Create a new catalog harvester.
   * create catalog harvester
   */
  async harvesterCreateRaw(
    requestParameters: HarvesterCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CatalogHarvester>> {
    const requestOptions = await this.harvesterCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CatalogHarvesterFromJSON(jsonValue)
    );
  }

  /**
   * Create a new catalog harvester.
   * create catalog harvester
   */
  async harvesterCreate(
    requestParameters: HarvesterCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CatalogHarvester> {
    const response = await this.harvesterCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for harvesterDelete without sending the request
   */
  async harvesterDeleteRequestOpts(
    requestParameters: HarvesterDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling harvesterDelete().'
      );
    }

    if (requestParameters["harvesterId"] == null) {
      throw new runtime.RequiredError(
        "harvesterId",
        'Required parameter "harvesterId" was null or undefined when calling harvesterDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/catalog-harvesters/{harvester_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{harvester_id}",
      encodeURIComponent(String(requestParameters["harvesterId"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Remove a specific catalog harvester.
   * delete catalog harvester
   */
  async harvesterDeleteRaw(
    requestParameters: HarvesterDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.harvesterDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Remove a specific catalog harvester.
   * delete catalog harvester
   */
  async harvesterDelete(
    requestParameters: HarvesterDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.harvesterDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for harvesterList without sending the request
   */
  async harvesterListRequestOpts(
    requestParameters: HarvesterListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling harvesterList().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/catalog-harvesters`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * List all catalog harvesters for a tenant.
   * list catalog harvesters
   */
  async harvesterListRaw(
    requestParameters: HarvesterListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PageCatalogHarvesterShort>> {
    const requestOptions = await this.harvesterListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PageCatalogHarvesterShortFromJSON(jsonValue)
    );
  }

  /**
   * List all catalog harvesters for a tenant.
   * list catalog harvesters
   */
  async harvesterList(
    requestParameters: HarvesterListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PageCatalogHarvesterShort> {
    const response = await this.harvesterListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for harvesterRetrieve without sending the request
   */
  async harvesterRetrieveRequestOpts(
    requestParameters: HarvesterRetrieveRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling harvesterRetrieve().'
      );
    }

    if (requestParameters["harvesterId"] == null) {
      throw new runtime.RequiredError(
        "harvesterId",
        'Required parameter "harvesterId" was null or undefined when calling harvesterRetrieve().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/catalog-harvesters/{harvester_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{harvester_id}",
      encodeURIComponent(String(requestParameters["harvesterId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return detailed information of an individual catalog harvester.
   * show catalog harvester details
   */
  async harvesterRetrieveRaw(
    requestParameters: HarvesterRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CatalogHarvester>> {
    const requestOptions = await this.harvesterRetrieveRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CatalogHarvesterFromJSON(jsonValue)
    );
  }

  /**
   * Return detailed information of an individual catalog harvester.
   * show catalog harvester details
   */
  async harvesterRetrieve(
    requestParameters: HarvesterRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CatalogHarvester> {
    const response = await this.harvesterRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for harvesterUpdate without sending the request
   */
  async harvesterUpdateRequestOpts(
    requestParameters: HarvesterUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling harvesterUpdate().'
      );
    }

    if (requestParameters["harvesterId"] == null) {
      throw new runtime.RequiredError(
        "harvesterId",
        'Required parameter "harvesterId" was null or undefined when calling harvesterUpdate().'
      );
    }

    if (requestParameters["catalogHarvester"] == null) {
      throw new runtime.RequiredError(
        "catalogHarvester",
        'Required parameter "catalogHarvester" was null or undefined when calling harvesterUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/catalog-harvesters/{harvester_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{harvester_id}",
      encodeURIComponent(String(requestParameters["harvesterId"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: CatalogHarvesterToJSON(requestParameters["catalogHarvester"]),
    };
  }

  /**
   * Update an existing catalog harvester.
   * update catalog harvester
   */
  async harvesterUpdateRaw(
    requestParameters: HarvesterUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CatalogHarvester>> {
    const requestOptions = await this.harvesterUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CatalogHarvesterFromJSON(jsonValue)
    );
  }

  /**
   * Update an existing catalog harvester.
   * update catalog harvester
   */
  async harvesterUpdate(
    requestParameters: HarvesterUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CatalogHarvester> {
    const response = await this.harvesterUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
